var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex py-4 align-center"},[_c('h2',[_vm._v("Checkout")]),_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Exit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }